import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { normalizePath } from './url-utils'

/**
 * URL Normalizer Component
 * Automatically redirects users to normalized URLs (without trailing slashes)
 * This prevents issues with route matching when browsers add trailing slashes
 */
export const UrlNormalizer = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const currentPath = location.pathname
    const normalizedPath = normalizePath(currentPath)

    // If the current path has a trailing slash and is not the root path, redirect to normalized version
    if (currentPath !== normalizedPath && currentPath !== '/') {
      console.log(`🔄 URL Normalizer: Redirecting from "${currentPath}" to "${normalizedPath}"`)
      // Preserve search parameters and hash when redirecting
      navigate(
        {
          pathname: normalizedPath,
          search: location.search,
          hash: location.hash,
        },
        { replace: true },
      )
    }
  }, [location.pathname, location.search, location.hash, navigate])

  return null // This component doesn't render anything
}
